exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#Cardinal-CCA-IFrame,#Cardinal-ModalContent{min-height:75vh}", ""]);

// exports
